import { styled, Accordion } from '@mui/material'

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  borderBottom: `1px solid`,
  borderColor: theme.palette.divider,
  '&:last-child': { borderBottom: 0 },
  '&::before': { display: 'none' },
  '&.Mui-expanded': { margin: 0 },
  '& .MuiAccordionSummary-content.Mui-expanded, & .MuiAccordionSummary-content': { marginTop: 0, marginBottom: 0, overflow: 'auto' },
}))
